/* GSH telemetry — original lightweight error/event logging hook. Captures JS errors + key funnel events; forwards to console by default, or to a configured endpoint (settings.telemetry_endpoint) if set — never required, fails silently. */
window.GSHTelemetry = (function(){
  var ENDPOINT = window.__gshTelemetryEndpoint || null;
  function send(payload){
    try { console.info('[GSH]', payload); } catch(e){}
    if (!ENDPOINT) return;
    try {
      fetch(ENDPOINT, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(payload), keepalive: true }).catch(function(){});
    } catch(e){}
  }
  window.addEventListener('error', function(e){
    send({ type:'js_error', message: e.message, source: e.filename, line: e.lineno, page: location.pathname, ts: Date.now() });
  });
  window.addEventListener('unhandledrejection', function(e){
    send({ type:'unhandled_rejection', reason: String(e.reason), page: location.pathname, ts: Date.now() });
  });
  document.addEventListener('gsh:cart:add', function(e){ send({ type:'add_to_cart', detail: e.detail, ts: Date.now() }); });
  return { log: send };
})();
